export default __webpack_public_path__ + "images/mcProgressLogo.v-3d67707b5b9746dc106046a643d3fa78.png";